import {
  Category,
  PopulationData,
  CityDataType,
  CityData,
  POIData,
  GeoData
} from '../types';

export async function fetchPopulationData(type: Category) {
  const csv = await fetchCSV(
    '/data/01/' + getFilenameFromPopulationDataType(type)
  );
  // 引数としてカテゴリー（区、町名など）を受け取り、該当データを読み込む
  // key_code,pref_name,city_name,area_name,data_type,year,month,setai,total,male,female,less15,age15_65,over65,over75,over85,m0,m5,m10,m15,m20,m25,m30,m35,m40,m45,m50,m55,m60,m65,m70,m75,m80,m85,m90,m95,m100,m_other,m_less15,m_15_65,m_over65,m_over75,m_over85,f0,f5,f10,f15,f20,f25,f30,f35,f40,f45,f50,f55,f60,f65,f70,f75,f80,f85,f90,f95,f100,f_other,f_less15,f_15_65,f_over65,f_over75,f_over85
  // 類似地域表示の条件（包括支援のみなのかどうか？）によって、読み取るカラムの長さが違うため、後から修正が必要な可能性あり
  const data: PopulationData[] = csv
    .map(c => ({
      keyCode: c[0] || '',
      prefName: c[1] || '',
      cityName: c[2] || '',
      areaName: c[3] || '',
      dataType: c[4] || '',
      year: c[5] ? parseInt(c[5], 10) : 0,
      month: c[6] ? parseInt(c[6], 10) : 0,
      setai: c[7] ? parseInt(c[7], 10) : 0,
      all: {
        total: c[8] ? parseInt(c[8], 10) : 0,
        less15: c[11] ? parseInt(c[11], 10) : 0,
        age15_65: c[12] ? parseInt(c[12], 10) : 0,
        over65: c[13] ? parseInt(c[13], 10) : 0,
        over75: c[14] ? parseInt(c[14], 10) : 0,
        over85: c[15] ? parseInt(c[15], 10) : 0
      },
      male: {
        total: c[9] ? parseInt(c[9], 10) : 0,
        less15: c[38] ? parseInt(c[38], 10) : 0,
        age15_65: c[39] ? parseInt(c[39], 10) : 0,
        over65: c[40] ? parseInt(c[40], 10) : 0,
        over75: c[41] ? parseInt(c[41], 10) : 0,
        over85: c[42] ? parseInt(c[42], 10) : 0,
        p0: c[16] ? parseInt(c[16], 10) : 0,
        p5: c[17] ? parseInt(c[17], 10) : 0,
        p10: c[18] ? parseInt(c[18], 10) : 0,
        p15: c[19] ? parseInt(c[19], 10) : 0,
        p20: c[20] ? parseInt(c[20], 10) : 0,
        p25: c[21] ? parseInt(c[21], 10) : 0,
        p30: c[22] ? parseInt(c[22], 10) : 0,
        p35: c[23] ? parseInt(c[23], 10) : 0,
        p40: c[24] ? parseInt(c[24], 10) : 0,
        p45: c[25] ? parseInt(c[25], 10) : 0,
        p50: c[26] ? parseInt(c[26], 10) : 0,
        p55: c[27] ? parseInt(c[27], 10) : 0,
        p60: c[28] ? parseInt(c[28], 10) : 0,
        p65: c[29] ? parseInt(c[29], 10) : 0,
        p70: c[30] ? parseInt(c[30], 10) : 0,
        p75: c[31] ? parseInt(c[31], 10) : 0,
        p80: c[32] ? parseInt(c[32], 10) : 0,
        p85: c[33] ? parseInt(c[33], 10) : 0,
        p90: c[34] ? parseInt(c[34], 10) : 0,
        p95: c[35] ? parseInt(c[35], 10) : 0,
        p100: c[36] ? parseInt(c[36], 10) : 0,
        other: c[37] ? parseInt(c[37], 10) : 0
      },
      female: {
        total: c[10] ? parseInt(c[10], 10) : 0,
        less15: c[65] ? parseInt(c[65], 10) : 0,
        age15_65: c[66] ? parseInt(c[66], 10) : 0,
        over65: c[67] ? parseInt(c[67], 10) : 0,
        over75: c[68] ? parseInt(c[68], 10) : 0,
        over85: c[69] ? parseInt(c[69], 10) : 0,
        p0: c[43] ? parseInt(c[43], 10) : 0,
        p5: c[44] ? parseInt(c[44], 10) : 0,
        p10: c[45] ? parseInt(c[45], 10) : 0,
        p15: c[46] ? parseInt(c[46], 10) : 0,
        p20: c[47] ? parseInt(c[47], 10) : 0,
        p25: c[48] ? parseInt(c[48], 10) : 0,
        p30: c[49] ? parseInt(c[49], 10) : 0,
        p35: c[50] ? parseInt(c[50], 10) : 0,
        p40: c[51] ? parseInt(c[51], 10) : 0,
        p45: c[52] ? parseInt(c[52], 10) : 0,
        p50: c[53] ? parseInt(c[53], 10) : 0,
        p55: c[54] ? parseInt(c[54], 10) : 0,
        p60: c[55] ? parseInt(c[55], 10) : 0,
        p65: c[56] ? parseInt(c[56], 10) : 0,
        p70: c[57] ? parseInt(c[57], 10) : 0,
        p75: c[58] ? parseInt(c[58], 10) : 0,
        p80: c[59] ? parseInt(c[59], 10) : 0,
        p85: c[60] ? parseInt(c[60], 10) : 0,
        p90: c[61] ? parseInt(c[61], 10) : 0,
        p95: c[62] ? parseInt(c[62], 10) : 0,
        p100: c[63] ? parseInt(c[63], 10) : 0,
        other: c[64] ? parseInt(c[64], 10) : 0
      },
      similarity: {
        similarClusterIndex: c[70] ? parseInt(c[70]) : 0,
        similarAreaCategoryName: c[71] || '',
        similarAreaSummaryText: c[72] || '',
        similarAreaFeatureText: c[73] || '',
        top3SimilarAreaName: c[74] || ''
      },
      // 以下カラム番号変更の必要あり
      support: {
        supportNeed_1: c[75] ? parseInt(c[75]) : 0,
        supportNeed_2: c[76] ? parseInt(c[76]) : 0,
        lSupportNeed_1: c[77] ? parseInt(c[77]) : 0,
        lSupportNeed_2: c[78] ? parseInt(c[78]) : 0,
        lSupportNeed_3: c[79] ? parseInt(c[79]) : 0,
        lSupportNeed_4: c[80] ? parseInt(c[80]) : 0,
        lSupportNeed_5: c[81] ? parseInt(c[81]) : 0
      }
    }))
    .filter(c => !isNaN(c.year));
  return data;
}

export function fetchGeoData(type: Category): Promise<GeoData> {
  // 該当するカテゴリーのポリゴンデータを取得
  return fetchJSON('/data/02/' + getFilenameFromGeoPopulationDataType(type));
}

export async function fetchCityData(type: CityDataType): Promise<CityData[]> {
  const csv = await fetchCSV('/data/03/' + getFilenameFromCityDataType(type));
  const filtered = csv.filter(c => c[2] !== '川崎市');
  switch (type) {
    case CityDataType.Abuse2016:
      return filtered
        .filter(c => parseInt(c[3], 10) === 2016)
        .map(c => ({
          city: c[2],
          [type]: parseInt(c[4], 10) + parseInt(c[5], 10)
        }));
    case CityDataType.Abuse2017:
      return filtered
        .filter(c => parseInt(c[3], 10) === 2017)
        .map(c => ({
          city: c[2],
          [type]: parseInt(c[4], 10) + parseInt(c[5], 10)
        }));
    case CityDataType.PhysicallyHandicapped:
      return filtered
        .filter(c => parseInt(c[3], 10) === 2016)
        .map(c => ({
          city: c[2],
          [type]: parseInt(c[4], 10)
        }));
    case CityDataType.IntellectualHandicapped:
      return filtered
        .filter(c => parseInt(c[3], 10) === 2016)
        .map(c => ({
          city: c[2],
          [type]: parseInt(c[12], 10)
        }));
    case CityDataType.JoinCommunity:
      return filtered
        .filter(c => parseInt(c[3], 10) === 2017)
        .map(c => ({
          city: c[2],
          [type]: parseInt(c[7], 10)
        }));
    case CityDataType.NursingCare:
      return filtered
        .filter(c => parseInt(c[3], 10) === 2016)
        .map(c => ({
          city: c[2],
          [type]: parseInt(c[5], 10)
        }));
    default:
  }
  return [];
}

export function fetchPOIData(): Promise<POIData> {
  return fetchJSON('/data/04/POI.geojson');
}

function getFilenameFromPopulationDataType(type: Category): string {
  switch (type) {
    case Category.Chome:
      return 'A_chome.csv';
    case Category.Chikushakyo:
      return 'B_chikushakyo.csv';
    case Category.Hokatsushien:
      return 'C_hokatsushien.csv';
    case Category.Chikuminjikyo:
      return 'D_chikuminjikyo.csv';
    case Category.Mimamori:
      return 'E_mimamori.csv';
    case Category.ElementarySchool:
      return 'F_elementaryschool.csv';
    case Category.JuniorHighSchool:
      return 'G_juniorhighschool.csv';
    case Category.Ku:
      return 'H_ku.csv';
    default:
  }
  return '';
}

function getFilenameFromGeoPopulationDataType(type: Category): string {
  switch (type) {
    case Category.Chome:
      return 'A_chome.geojson';
    case Category.Chikushakyo:
      return 'B_chikushakyo.geojson';
    case Category.Hokatsushien:
      return 'C_hokatsushien.geojson';
    case Category.Chikuminjikyo:
      return 'D_chikuminjikyo.geojson';
    case Category.Mimamori:
      return 'E_mimamori.geojson';
    case Category.ElementarySchool:
      return 'F_elementaryschool.geojson';
    case Category.JuniorHighSchool:
      return 'G_juniorhighschool.geojson';
    case Category.Ku:
      return 'H_ku.geojson';
    default:
  }
  return '';
}

function getFilenameFromCityDataType(type: CityDataType): string {
  switch (type) {
    case CityDataType.Abuse2016:
      return 'abuse.csv';
    case CityDataType.Abuse2017:
      return 'abuse.csv';
    case CityDataType.PhysicallyHandicapped:
      return 'handicapped.csv';
    case CityDataType.IntellectualHandicapped:
      return 'handicapped.csv';
    case CityDataType.JoinCommunity:
      return 'join_community.csv';
    case CityDataType.NursingCare:
      return 'nursing_care.csv';
    default:
  }
  return '';
}

async function fetchCSV(url: string) {
  const res = await window.fetch(url);
  if (res.status >= 300) {
    throw new Error('failed to fetch');
  }
  const text = await res.text();
  return text.split('\n').map(l => l.split(','));
}

async function fetchJSON(url: string) {
  const res = await window.fetch(url);
  if (res.status >= 300) {
    throw new Error('failed to fetch');
  }
  return res.json();
}
